const _onlyNumber = (text: string):string => {
  if (!text)
    return '';
  if (/^[0-9]*$/.test(text) || text.length == 0)
    return text.trim();
  text = text.replace(/[^0-9]/, '');
  return _onlyNumber(text);
}


export const onlyNumber = (text: string) => {
  return _onlyNumber(text);
}

export const isValidPhone = (phone: string) => {
  if (phone.length != 10)
    return false;
  if (phone.substring(0, 1) == "1")
    return false;
  if (phone.substring(1, 2) == "9")
    return false;
  return true;
}
/**
* 首字母大写
* @param {any} str
*/
export const ucfirst = (str: string) => {
  if (!str) {
    return '';
  }
  str = str.toLowerCase();
  const strarr = str.split(' ');
  let result = '';
  for (let i = 0; i < strarr.length; i++) {
    if (i > 0) {
      result += " ";
    }
    result += strarr[i].substring(0, 1).toUpperCase() + strarr[i].substring(1);
  }

  return result;
}

/**
 * 获取URL中的指定参数值
 * 如果参数不存在，返回空字符串
 * 
 * @param name {string} 想要获取的URL参数名称
 * @returns {string} 解码后的URL参数值，如果参数不存在则返回空字符串
 */
export const getUrlParameter = (name: string) => {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  const results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}